
import Layout from "@/components/Layout";
import NotFoundContent from "@/components/not-found/NotFoundContent";

const NotFound = () => {
  return (
    <Layout>
      <NotFoundContent />
    </Layout>
  );
};

export default NotFound;
